import { render, staticRenderFns } from "./CellAvatar.vue?vue&type=template&id=1df3e3f6"
import script from "./CellAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./CellAvatar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports